import $ from 'jquery';
import * as helpers from '../global/helpers';
import { closeMobileMenu } from './main-menu';

const searchForm = {
	/**
	 * The class to apply to the formEl when it is active.
	 *
	 * @since 1.0.0
	 */
	formActiveClass: 'active',

	/**
	 * Boolean to check if the search form us currently open, or not.
	 *
	 * @since 1.0.0
	 */
	isFormOpen: false,

	/**
	 * Get form elements and setup events.
	 *
	 * @since 1.0.0
	 */
	init() {
		this.formEl = document.getElementById('js-site-search');
		this.searchInput = this.formEl.querySelector('.search-field');
		this.triggers = document.querySelectorAll('.js-search-form-trigger');

		this.handleTriggerClick = this.handleTriggerClick.bind(this);
		helpers.forEach(this.triggers, (i, trigger) => {
			trigger.addEventListener('click', this.handleTriggerClick);
		});

		this.maybeCloseSearchForm = this.maybeCloseSearchForm.bind(this);
		document.addEventListener('click', this.maybeCloseSearchForm);
		document.addEventListener('keyup', this.maybeCloseSearchForm);
	},

	/**
	 * Toggle the form open and closed when triggers are clicked.
	 *
	 * @since 1.0.0
	 *
	 * @param {Event} e
	 */
	handleTriggerClick() {
		if (this.isFormOpen) {
			this.closeForm();
		} else {
			this.openForm();
		}
	},

	/**
	 * Close the form if the user clicks outside of the form.
	 *
	 * @since 1.0.0
	 *
	 * @param {Event} e
	 */
	maybeCloseSearchForm(e) {
		switch (e.type) {
			case 'keyup': {
				/**
				 * Close the form if the escape key is pressed and the form is open.
				 */
				if (e.keyCode === 27 && this.isFormOpen) {
					this.closeForm();
				}
				break;
			}

			case 'click': {
				const $target = $(e.target);
				const $closestTrigger = $target.closest('.js-search-form-trigger');
				const $closestSearchForm = $target.closest('#js-site-search');

				/**
				 * Close the form only if it's open, and the event target
				 * isn't a form trigger or the form itself.
				 */
				if (this.isFormOpen && $closestTrigger.length === 0 && $closestSearchForm.length === 0) {
					this.closeForm();
				}
				break;
			}

			default:
				break;
		}
	},

	/**
	 * Open the form, focus on input, and toggle aria attributes.
	 *
	 * @since 1.0.0
	 */
	openForm() {
		closeMobileMenu();
		this.formEl.classList.add(this.formActiveClass);
		this.formEl.setAttribute('aria-hidden', 'false');
		this.searchInput.focus();
		this.isFormOpen = !this.isFormOpen;
		this.toggleTriggerState();
	},

	/**
	 * Close the form, blur input, and toggle aria attributes.
	 *
	 * @since 1.0.0
	 */
	closeForm() {
		this.formEl.classList.remove(this.formActiveClass);
		this.formEl.setAttribute('aria-hidden', 'true');
		this.searchInput.blur();
		this.isFormOpen = !this.isFormOpen;
		this.toggleTriggerState();
	},

	/**
	 * Toggle the visible text for all search triggers using "aria-hidden".
	 *
	 * @since 1.0.0
	 */
	toggleTriggerState() {
		helpers.forEach(this.triggers, (i, trigger) => {
			trigger.classList.toggle('active');
			const visibleText = trigger.querySelector('.search-trigger__text[aria-hidden="false"]');
			const hiddenText = trigger.querySelector('.search-trigger__text[aria-hidden="true"]');

			if (visibleText && hiddenText) {
				visibleText.setAttribute('aria-hidden', 'true');
				hiddenText.setAttribute('aria-hidden', 'false');
			}
		});
	},
};

document.addEventListener('DOMContentLoaded', () => {
	searchForm.init();
});
